<div id="customSign" class="position-relative" (keyup.enter)="next()">
    <div class="headerDialog">
        <h1 class="dialogTitle">{{ 'signaturit_pro.signComponent.sign_cert_' + sigType | translate }}</h1>
        <button [ngClass]="(showLoader && !isLocalSign) ? 'disabled' : 'allow'"
            id="cancelled" mat-icon-button mat-dialog-close (click)="closeModal()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <ng-container *ngIf="!firstFormGroup.valid">
            <mat-action-list role="list">
                <mat-list-item *ngFor="let key of sigTypesKeys" role="listitem" (click)="setSignType(key)"
                    class="list-dynsig-item">
                    <em [class]="sigTypes[key].icon"></em>
                    <span>{{sigTypes[key].label|translate:_transParam }}</span>
                </mat-list-item>
            </mat-action-list>
        </ng-container>
        <mat-horizontal-stepper (selectionChange)="onStepChange($event)" linear #stepper
            [hidden]="!firstFormGroup.valid && !showStepper" [ngClass]="{'hide-stepper-header': !showStepper}">
            <mat-step [stepControl]="secondFormGroup" [editable]="true" *ngIf="hasSecondStep">
                <ng-template matStepLabel>{{ 'dialog_sign_step_x_label'|translate : {valueParam: secondStep} }}
                </ng-template>
                <ng-template loadSigType #componentOne></ng-template>
            </mat-step>
            <mat-step [stepControl]="thirdFormGroup" [editable]="sendedOTP">
                <ng-template matStepLabel>{{ 'dialog_sign_step_x_label'|translate : {valueParam: thirdStep} }}
                </ng-template>
                <ng-template loadSigType #componentTwo></ng-template>
            </mat-step>
            <mat-step *ngIf="hasFourthStep">
                <ng-template matStepLabel>{{ 'dialog_sign_step_x_label'|translate : {valueParam: fourthStep} }}
                </ng-template>
                <ng-template loadSigType #componentThree></ng-template>
            </mat-step>
        </mat-horizontal-stepper>
    </div>
    <div class="footerButton" mat-dialog-actions *ngIf="firstFormGroup.valid">
      <signaturit-button class="btn1"
          *ngIf="onlyLoginSAMLSIG && !tokenIvSign && (sigType === 'SIG' || sigType === 'SIGQSCD') && !_finishProService.isLocalSign"
          text="{{ !labelButtonSAML ? (samlBtnLabel | translate)  : (labelButtonSAML) }}"
          type="primary" size="md" (click)="redirectSAML()">
      </signaturit-button>
      <signaturit-button *ngIf="clearBtnLabel.length && !onlyLoginSAMLSIG"
          text="{{ clearBtnLabel | translate:_transParam }}" type="tertiary" size="md"
          (click)="clear()"></signaturit-button>
      <signaturit-button class="btn2" *ngIf="(!onlyLoginSAMLSIG || onlyLoginSAMLSIG && (tokenIvSign || _finishProService.isLocalSign)) && (sigType === 'SIG' || sigType === 'SIGQSCD')"
          [disabled]="disableButtonSign || blockSigbio || showLoader"
          text="{{ 'signaturit_pro.signComponent.button_accept' | translate:_transParam }}" type="primary" size="md"
          [showLoader]="showLoader" (click)="next()"></signaturit-button>
  </div>
    <div id="hiddenWeb">
        <div class="containerMessage">
            <p class="device">{{'message_webSocket'|translate:_transParam }}</p>
            <mat-icon class="device-icon">devices</mat-icon>
            <div class="spinner"></div>
        </div>
    </div>
</div>
